import { useAdminPermissions } from '@infl-ts/util-use-admin-permissions';
import * as DE from '@nll/datum/lib/DatumEither';
import { constNull, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import { createContext } from 'react';
import { useLenses } from './use-lenses';
import { useProfileFlags } from './use-profile-flags';
import { jsx as _jsx } from "react/jsx-runtime";
export var LensContext = /*#__PURE__*/createContext(null);

var LensContextProvider = function LensContextProvider(_ref) {
  var profileId = _ref.profileId,
      permissions = _ref.permissions,
      children = _ref.children;
  return pipe(useLenses(permissions, profileId), function (lens) {
    return /*#__PURE__*/_jsx(LensContext.Provider, {
      value: lens,
      children: children
    });
  });
};

var AdminLensProvider = function AdminLensProvider(_ref2) {
  var children = _ref2.children,
      permissions = _ref2.permissions;
  return pipe(useProfileFlags(), DE.chain(function (_ref3) {
    var _ref3$profile = _ref3.profile,
        id = _ref3$profile.id,
        isAdmin = _ref3$profile.isAdmin,
        isClone = _ref3$profile.isClone;
    return isAdmin || isClone ? DE.success(id) : DE.failure(undefined);
  }), DE.squash(constNull, function () {
    return /*#__PURE__*/_jsx(LensContext.Provider, {
      value: null,
      children: children
    });
  }, function (profileId) {
    return /*#__PURE__*/_jsx(LensContextProvider, {
      profileId: profileId,
      permissions: permissions,
      children: children
    });
  }));
};

export var LensProvider = function LensProvider(_ref4) {
  var children = _ref4.children;
  return pipe(useAdminPermissions(), O.match(function () {
    return /*#__PURE__*/_jsx(LensContext.Provider, {
      value: null,
      children: children
    });
  }, function (permissions) {
    return /*#__PURE__*/_jsx(AdminLensProvider, {
      permissions: permissions,
      children: children
    });
  }));
};